export enum ChargeDisplayStatusEnum {
  PENDING = 'PENDING',
  UNPAID = 'UNPAID',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
  VOIDED = 'VOIDED',
  EXTERNALLY_MANAGED = 'EXTERNALLY_MANAGED',
  NO_INVOICE = 'NO_INVOICE',
}
